import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '@mui/material';
import DialogModal from '../../../components/DialogModal/DialogModal';
import {
  StyledTextField,
  ModalContainer,
  ModalTitle,
} from './styles';
import texts from './texts.json';

const EditCoachProfileModal = ({
  onUpdateProfile,
  profileMarkdown,
  ...modalProps
}) => {
  const [profileText, setProfileText] = useState(profileMarkdown);

  return (
    <>
      <DialogModal
        open={modalProps.isOpen}
        onClose={modalProps.onDidDismiss}
        maxWidth="md"
        fullWidth
      >
        <ModalContainer>
          <ModalTitle>{texts.editProfileTitle}</ModalTitle>
          <StyledTextField
            variant="outlined"
            value={profileText}
            onChange={(e) => setProfileText(e.target.value)}
            multiline
            minRows={10}
            fullWidth
          />
          <Button
            fullWidth
            variant="contained"
            onClick={() => onUpdateProfile(profileText)}
          >
            {texts.save}
          </Button>
        </ModalContainer>
      </DialogModal>
    </>
  );
};

EditCoachProfileModal.propTypes = {
  onUpdateProfile: PropTypes.func.isRequired,
  profileMarkdown: PropTypes.string.isRequired,
};

export default EditCoachProfileModal;
